import ChoiceGroup, { choiceGroupLayouts } from "components/ChoiceGroup";
import Flex, { GAP_CLASS } from "components/Flex";
import { ALIGN_CLASS, DIRECTION_CLASS } from "components/Flex/Flex";
import InfoBox, { infoBoxVariants } from "components/InfoBox";
import { SOFT_GATE } from "constants/proposals";
import { bool, func, string } from "prop-types";

import classes from "./GateTransitionNotice.module.scss";

const SKIP_OPTIONS = [
  { value: true, label: "Yes", ariaLabel: "Skip questions: Yes" },
  { value: false, label: "No", ariaLabel: "Skip questions: No" },
];

const GateTransitionNotice = ({
  fromTitle,
  toTitle,
  gateMode,
  skipped,
  onSkipChange,
  note,
  onNoteChange,
}) => {
  const isSoftGate = gateMode === SOFT_GATE;

  return (
    <InfoBox
      variant={infoBoxVariants.info}
      footer={
        isSoftGate && (
          <Flex
            direction={DIRECTION_CLASS.column}
            alignItems={ALIGN_CLASS.stretch}
            gap={GAP_CLASS.GAP_300}
          >
            <ChoiceGroup
              layout={choiceGroupLayouts.row}
              question="Do you want to skip questions?"
              options={SKIP_OPTIONS}
              value={skipped}
              onChange={onSkipChange}
            />
            {skipped && (
              <textarea
                className={classes["gate_transition_notice__skip_note"]}
                aria-label="Optional note explaining why you skipped"
                placeholder="Optional note explaining why you skipped..."
                rows={3}
                value={note}
                onChange={(event) => onNoteChange(event.target.value)}
              />
            )}
          </Flex>
        )
      }
    >
      <span>
        You&apos;re about to move this card from{" "}
        <span className={classes["gate_transition_notice__stage"]}>{fromTitle}</span>
        {" → "}
        <span className={classes["gate_transition_notice__stage"]}>{toTitle}</span>
        {isSoftGate
          ? " and your set-up is on soft gate. With soft gates, you can skip these questions."
          : ". Your set-up is on hard gate, so every question must be answered before this move can be confirmed."}
      </span>
    </InfoBox>
  );
};

GateTransitionNotice.propTypes = {
  fromTitle: string,
  toTitle: string,
  gateMode: string.isRequired,
  skipped: bool.isRequired,
  onSkipChange: func.isRequired,
  note: string.isRequired,
  onNoteChange: func.isRequired,
};

export default GateTransitionNotice;
